import { render, staticRenderFns } from "./ExDetailDia.vue?vue&type=template&id=05937dca&scoped=true&"
import script from "./ExDetailDia.vue?vue&type=script&lang=js&"
export * from "./ExDetailDia.vue?vue&type=script&lang=js&"
import style0 from "./ExDetailDia.vue?vue&type=style&index=0&id=05937dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05937dca",
  null
  
)

export default component.exports